import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueRouter from 'vue-router'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex, axios, VueRouter)

const state = {
  loader: false,
  loaderToUpdate: false,
  defaultPaginationObj: {
    page: 1,
    pagesCount: 0,
    itemCount: 0,
    pageSize: 100,
    filters: {}
  },
  loginStatus: false,
  snackbarErrorObj: {
    snackbar: false,
    color: 'error',
    text: "",
    timeout: 10000,
  },
  loggedAdmin: {
    isLoggedIn: false,
    isSuperAdmin: false,
    companyId: null,
    token: null
  },
  gates: [
    {
      name: "Tümü",
      id: "all",
      children: [
        {
          id: "1",
          name: "Veri Girişi :",
          children: [
            { id: "[1-1]", name: "KDV Beyannamesi" },
            { id: "[1-2]", name: "ATİK Listesi" },
            { id: "[1-3]", name: "Doğrudan Yüklenim" },
            { id: "[1-4]", name: "İndirilecek KDV Listesi" },
            {
              id: "[1-5]", name: "Defter",
              children: [
                { id: "[1-5-1]", name: "Muavin" },
                { id: "[1-5-2]", name: "E-Defter" },
              ]
            },
            { id: "[1-6]", name: "Gümrük Beyannamesi" },
            { id: "[1-7]", name: "E-Fatura" },
            { id: "[1-8]", name: "GTB İhracat Fatura" },
            { id: "[1-9]", name: "Geçmiş KDV İade Listeleri" },
            { id: "[1-10]", name: "Kapasite Rapor" },
          ],
        },
        {
          id: "2",
          name: "Veri Doğrulama :",
          children: [
            { id: "[2-1]", name: "E-Fatura: Satış Faturaları" },
            { id: "[2-2]", name: "Gümrük: Satış Faturaları" },
            { id: "[2-3]", name: "İndirilecek KDV Listesi" },
            { id: "[2-4]", name: "GTB Fatura Listesi" },
          ],
        },
        {
          id: "3",
          name: "Veri Güncelleme :",
          children: [
            { id: "[3-1]", name: "Hammadde Stok" },
            {
              id: "[3-2]",
              name: "Ürün Ağacı",
              children: [
                { id: "[3-2-1]", name: "Liste" },
                { id: "[3-2-2]", name: "Fire" },
                { id: "[3-2-3]", name: "Muadil Ürün" },
              ],
            },
            { id: "[3-3]", name: "Kapasite Rapor" },
            { id: "[3-4]", name: "Gümrük" },
            { id: "[3-5]", name: "Mamül" },
            { id: "[3-6]", name: "KDV Beyannamesi" },
            { id: "[3-7]", name: "KDV İadem Muavin" },
            { id: "[3-8]", name: "İndirilecek KDV Listesi" },
            { id: "[3-9]", name: "ATİK Listesi" },
            { id: "[3-10]", name: "E-Fatura Listesi" },
          ],
        },
        {
          id: "4",
          name: "Hesaplama :",
          children: [
            { id: "[4-1]", name: "Ön Bilgiler" },
            { id: "[4-2]", name: "Yüklenim" },
          ],
        },
        {
          id: "5",
          name: "Raporlar :",
          children: [
            { id: "[5-1]", name: "Satış Faturaları Listesi" },
            { id: "[5-2]", name: "GÇB Listesi" },
            { id: "[5-3]", name: "Yüklenim" },
            { id: "[5-4]", name: "Detay Rapor" },
            { id: "[5-5]", name: "Kapasite Rapor" },
            { id: "[5-6]", name: "İndirilecek KDV Listesi" },
            { id: "[5-7]", name: "Satış Faturaları Listesi 2" },
          ],
        },
        {
          id: "6",
          name: "Yardımcı Programlar :",
          children: [
            { id: "[6-1]", name: "İndirilecek KDV Listesi Oluşturma" },
            { id: "[6-2]", name: "KDV Beyannamesi Dönüşümü" },
          ],
        },
        {
          id: "100",
          name: "Karşıt İnceleme : - Veri Girişi",
          children: [
            { id: "[100-1]", name: "İndirilecek KDV Listesi" },
            { id: "[100-2]", name: "E-Defter Berat" },
            { id: "[100-3]", name: "Beyannameler" },
            { id: "[100-4]", name: "Muaf Şirket Listesi" },
            { id: "[100-5]", name: "Yüklenim" },
            { id: "[100-6]", name: "Cari Bilgiler" },
          ],
        },
        {
          id: "101",
          name: "Karşıt İnceleme : - Veri Güncelleme",
          children: [
            { id: "[101-1]", name: "İndirilecek KDV Listesi" },
            { id: "[101-2]", name: "Cari Bilgiler" },
            { id: "[101-4]", name: "KDV1 Beyanname" },
            { id: "[101-5]", name: "Muhtasar Beyanname" },
            { id: "[101-6]", name: "Yüklenim" },
          ],
        },
        {
          id: "102",
          name: "Karşıt İnceleme : - Hesaplama",
          children: [
            { id: "[102-1]", name: "Tutanak" },
            { id: "[102-3]", name: "Tam Tasdik" },
            { id: "[102-4]", name: "İnd Kdv Listesi Oluşturma" },
          ],
        },
        {
          id: "103",
          name: "Karşıt İnceleme : - Dosya Takibi",
          children: [
            { id: "[103-1]", name: "Dosya Takibi" },
          ],
        },
      ],
    },
  ]
};
const getter = {};
const mutations = {
  LOADER(state, payload) {
    state.loader = payload;
  },
  LOADERTOUPDATE(state, data) {
    state.loaderToUpdate = data.loaderToUpdate
    state.loaderText = data.loaderText
  },
  CHANGE_LOGIN_STATUS(state, newStatus) {
    state.loggedAdmin.isSuperAdmin = newStatus.isSuperAdmin
    state.loggedAdmin.isLoggedIn = newStatus.isLoggedIn
    state.loggedAdmin.token = newStatus.token
    state.loggedAdmin.companyId = newStatus.companyId
  }
};
const actions = {
  changeLoginStatus(context, loginObj) {
    context.commit('CHANGE_LOGIN_STATUS', loginObj)
  }
};

const store = new Vuex.Store({
  plugins: [createPersistedState({
    key: 'admin',
    storage: {
      getItem: (key) => ls.get(key),
      setItem: (key, value) => ls.set(key, value),
      removeItem: (key) => ls.remove(key),
    },
  })],
  state,
  getter,
  mutations,
  actions,
})
export default store;

